import { makeAutoObservable } from 'mobx';
import type { RootStore } from './root-store';

export class BannerInvestownStore {
    rootStore: RootStore;

    isClosed: boolean = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    get canShowBanner(): boolean {
        // Lazy check - kontroluje cookie při každém přístupu
        // Pokud je již zavřeno v paměti, nemusíme kontrolovat cookie
        if (this.isClosed) {
            return false;
        }

        // První kontrola z cookie (pro případ refresh stránky)
        if (this.rootStore.cookieService?.hasInvestownBannerClosed()) {
            return false;
        }

        return true;
    }

    closeBanner(): void {
        this.isClosed = true;
        this.rootStore.cookieService.setInvestownBannerClosed();
    }
}
